import React from "react";
import { FaPlayCircle, FaPauseCircle, FaHeart, FaRegHeart } from "react-icons/fa";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { FaRegClosedCaptioning } from "react-icons/fa6";
import { MdReplay10, MdForward10 } from "react-icons/md";
import { RiForward10Fill } from "react-icons/ri";
import { GrForwardTen } from "react-icons/gr";
import { TbRewindForward10, TbRewindBackward10 } from "react-icons/tb";
import "./AudioPlayerV2.css";

export default function AudioPlayerV2({
  isPlaying,
  currentTime,
  duration,
  progress,
  playbackRate,
  onPlayPause,
  onSeek,
  onSpeedChange,
  showTranslations,
  onToggleTranslations,
  isFavorite,
  onFavoriteClick,
  onPrevSection,
  onNextSection,
  onSkipBack,
  onSkipForward,
}) {
  const formatTime = (t) =>
    !t || isNaN(t)
      ? "0:00"
      : `${Math.floor(t / 60)}:${Math.floor(t % 60).toString().padStart(2, "0")}`;

  return (
    <div className="apv2-wrapper apv2-sticky">
      <div className="apv2-bar">

        {/* ── Progress bar + timestamps ── */}
        <div className="apv2-progress-section">
          <input
            type="range"
            min="0"
            max="100"
            step="0.1"
            value={progress}
            onChange={onSeek}
            className="apv2-slider"
            style={{ '--progress': `${progress}%` }}
          />
          <div className="apv2-time-row">
            <span>{formatTime(currentTime)}</span>
            <span>{formatTime(duration)}</span>
          </div>
        </div>

        {/* ── Controls row ──
              3-col grid: [1fr left-group] [auto ▶] [1fr right-group]
              Left: ♥ far-left, 1x far-right  |  Right: CC far-left   */}
        <div className="apv2-controls-row">
          <div className="apv2-left-group">
            <select className="apv2-speed" value={playbackRate} onChange={onSpeedChange}>
              {[0.5, 0.75, 1, 1.25, 1.5, 2].map((r) => (
                <option key={r} value={r}>{r}x</option>
              ))}
            </select>
          </div>

          <div className="apv2-center-group">
            <button className="apv2-skip-btn" onClick={onSkipBack}>
              <TbRewindBackward10 size={25} />
            </button>

            <button className="apv2-play-btn" onClick={onPlayPause}>
              {isPlaying ? <FaPauseCircle size={54} /> : <FaPlayCircle size={54} />}
            </button>

            <button className="apv2-skip-btn" onClick={onSkipForward}>
              <TbRewindForward10 size={25} />
            </button>

          </div>

          <div className="apv2-right-group">
            <button className={`apv2-cc-btn${showTranslations ? " active" : ""}`} onClick={onToggleTranslations}>
              <FaRegClosedCaptioning size={22} color={showTranslations ? "var(--color-primary)" : "#929292"} />
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
